module.exports = __webpack_public_path__ + "static/img/niushe1.d690e4a0.png";